import ClientDeliveryService from '@/services/ClientDeliveryService';

export default {
  /* eslint-disable no-console */
  namespaced: true,

  state: {
    pendingDeliveriesCount: 0,
    loadingCount: false,
  },

  mutations: {
    SET_PENDING_COUNT(state, count) {
      state.pendingDeliveriesCount = count;
    },
    SET_LOADING(state, status) {
      state.loadingCount = status;
    },
  },

  actions: {
    async fetchPendingCount({ commit, rootState }) {
      const storeId = rootState.authUserData?.user_claims?.store;
      if (!storeId) {
        console.warn('Seguridad: Usuario sin sucursal asignada. Se abortó la consulta de entregas.');
        commit('SET_PENDING_COUNT', 0);
        return;
      }

      commit('SET_LOADING', true);
      try {
        const count = await ClientDeliveryService.getReadyToDeliverCount(storeId);
        commit('SET_PENDING_COUNT', count);
      } catch (error) {
        console.error('Error al obtener contador de entregas listas:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },

  getters: {
    hasPendingDeliveries: (state) => state.pendingDeliveriesCount > 0,
    pendingCount: (state) => state.pendingDeliveriesCount,
  },
};
